module.exports = __webpack_public_path__ + "media/svg/LockFill-57dcddf6.svg";